import { pbrExt } from './fragments/alpha-test-fragment.js';
import { _registerPbrExt } from './pbr-flags.js';

function setPbrAlphaCutoff(mat, alphaCutOff) {
  mat._alphaCutOff = alphaCutOff;
  _registerPbrExt(pbrExt);
}

export { setPbrAlphaCutoff };
//# sourceMappingURL=set-alpha-cutoff.js.map
